import React, {useState, useEffect} from "react";
import "../../../../src/styles/userManagement.css";
import PropTypes from "prop-types";
import { Input } from "@appkit4/react-components/field";
import { Pagination } from "@appkit4/react-components/pagination";
import {Table, Column} from "@appkit4/react-components/table";
export default function AuditHistoryTable(props) {
  const { AuditData, Loading } = props;
  const [tableData, setTableData] = useState([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalPage, setTotalPage] = useState(500);

  useEffect(() => {
    setTableData(AuditData);
    setFilter(AuditData);
    let totalPageLength = Math.ceil((AuditData.length)/10);
    if (totalPageLength === 0) {
        totalPageLength = 1;
    }
    setTotalPage(totalPageLength);
  }, [AuditData]);

  useEffect(() => {
    const result = tableData?.filter((auditData) => {
      return auditData.description.toLowerCase().match(search.toLocaleLowerCase());
    });
    setFilter(result);
  }, [search]);

  function formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [day, month, year].join('-');
  }

  const renderDate = (row) => {
    return formatDate(row?.created_date)
  }

  const sortFuncForOrder1 = (a, b) => {
    const firstOrderId = (a.auditid.toString()).charAt(1);
    const secondOrderId = (b.auditid.toString()).charAt(1);
    return firstOrderId > secondOrderId ? 1 : -1;;
}

const sortFuncForOrder2 = (a, b) => {
    const firstOrderId = (a.auditid.toString()).charAt(1);
    const secondOrderId = (b.auditid.toString()).charAt(1);
    return firstOrderId < secondOrderId ? 1 : -1;;
}

  return (
    <div className="App">
      {Loading ? (
        <div className="row" id="preloader">
          <div className="col-12 col-lg-12 loader-margin text-center">
            <div className="a-loading a-primary a-m-10">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="col-lg-12 mt-3 pl-1">
            <div className="ap-table-demo menu-tableAlignment-width">
              {tableData.length > 0 ? (
                <Input
                type="text"
                title= "Search Description"
                value={search}
                className="ap-field-wrapper-tableSearch"
                onChange={(e) => setSearch(e)}
              /> 
              ) : ""}
                <Table originalData={filter} hasTitle currentPage={current} pageSize={10}>
                    <Column field="auditid" sortKey={filter.length > 0 ? "auditid" : ""} sortFunc1={sortFuncForOrder1} sortFunc2={sortFuncForOrder2}>Audit ID</Column>
                    <Column field="vendor_name" sortKey={filter.length > 0 ? "vendor_name" : ""}>Third Party Name</Column>
                    <Column field="vendorassessmentrequestid" sortKey={filter.length > 0 ? "vendorassessmentrequestid" : ""}>Third Party Request ID</Column>
                    <Column field="description" sortKey={filter.length > 0 ? "description" : ""}>Description</Column>
                    <Column field="status" sortKey={filter.length > 0 ? "status" : ""}>Status</Column>
                    <Column field="created_by" sortKey={filter.length > 0 ? "created_by" : ""}>Created By</Column>
                    <Column field="created_date" sortKey={filter.length > 0 ? "created_date" : ""} renderCell={renderDate}>Created date</Column>
                </Table>
                {filter.length === 0 ? (
                  <div className="noData">
                  No data available in table
                  </div>
                  ) : ("")}
                <Pagination
                  defaultCurrent={1}
                  current={current}
                  total={totalPage}
                  onPageChange={(page) => setCurrent(page)}
                >
                </Pagination>
            </div>
            </div>
      )}
    </div>
  );
}

AuditHistoryTable.propTypes = {
  AuditData: PropTypes.any, 
  Loading: PropTypes.any
}
